import { createAsyncThunk } from '@reduxjs/toolkit';
import {LargeDataAnalyticsHostname} from "../configs/Domain";
import _ from "lodash";
import axios from "axios";

export const optimizeShares = createAsyncThunk(
  'optimize/optimizeShares',
  async ({
    totalDollars = 100000,
    tolerance = 0.01,
    tickers,
    maxPositionPct,
    minPositionPct,
    maxDeviation,
    integerPositions = true
  }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${LargeDataAnalyticsHostname}/optimize/shares`, {
        total_dollars: totalDollars,
        tolerance,
        tickers,
        max_position_pct: maxPositionPct,
        min_position_pct: minPositionPct,
        max_deviation: maxDeviation,
        integer_positions: integerPositions
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          error: "Optimization failed",
          message: error.message
        }
      );
    }
  }
);
